import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/components/View';
import { memo, useCallback, useContext } from 'react';
import RouterTab from 'ui-addon-react-router-dom/RouterTab';
import RouterTabs from 'ui-addon-react-router-dom/RouterTabs';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { TABS_ID } from '../../../constants/tabs';
import { AppContext } from '../../../contexts/app/context';
import { PageLayoutPropsContext } from '../../../contexts/pageLayout/PropsContext';
import Notification from '../../common/Notification/Notification';
import PastMeetingsMenu from '../PastMeetingsMenu/PastMeetingsMenu';
import { ListsIcon } from 'foundations-assets/icons/components/ListsIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { ObjectAssociationsIcon } from 'foundations-assets/icons/components/ObjectAssociationsIcon';
import { BulletListIcon } from 'foundations-assets/icons/components/BulletListIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Tabs({
  getTabUrl,
  activeTab,
  currentTabHeigth
}) {
  const {
    tabsConfig,
    usageTracker,
    participants,
    notifications,
    myParticipantRole
  } = useContext(PageLayoutPropsContext);
  const {
    isLoading,
    appName
  } = useContext(AppContext);
  const notification = useCallback(tabId => {
    if (tabId === TABS_ID.contacts) return /*#__PURE__*/_jsx(Notification, {
      absolute: true,
      top: 2,
      usageTracker: usageTracker,
      appName: appName,
      participants: participants,
      notifications: notifications,
      myParticipantRole: myParticipantRole,
      children: /*#__PURE__*/_jsx("span", {})
    });
    return '';
  }, [appName, myParticipantRole, notifications, participants, usageTracker]);
  const getIconComponent = iconName => {
    switch (iconName) {
      case 'lists':
        return ListsIcon;
      case 'edit':
        return EditIcon;
      case 'objectAssociations':
        return ObjectAssociationsIcon;
      case 'bulletList':
        return BulletListIcon;
      default:
        return undefined;
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    borderBlockStartWidth: "100",
    borderBlockStartColor: "border-core-default",
    borderBlockStartStyle: "solid",
    backgroundColor: "fill-surface-default",
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(RouterTabs, {
      fill: true,
      "data-test-id": `${appName}-navigation`,
      children: tabsConfig.map((tab, index) => {
        const trackingTabName = `${tab.id === 'contacts' ? 'participants' : tab.id}`;
        const title = () => {
          if (index === activeTab && isLoading) {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(View, {
                position: "absolute",
                insetBlockStart: "100",
                insetInlineEnd: "100",
                children: /*#__PURE__*/_jsx(LoadingSpinner, {
                  size: "extra-small"
                })
              }), notification(tab.id)]
            });
          }
          return notification(tab.id);
        };
        return /*#__PURE__*/_jsx(RouterTab, {
          to: getTabUrl(tab.id),
          icon: getIconComponent(tab.icon),
          title: title(),
          "data-test-id": `${appName}-${tab.dataTestId}`,
          onClick: () => {
            usageTracker.trackInteraction(Object.assign({
              screen: SCREENS[trackingTabName]
            }, ACTIONS[trackingTabName].clickTab));
          },
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.tabs.${tab.id}`
          })
        }, tab.id);
      })
    }), /*#__PURE__*/_jsx(PastMeetingsMenu, {
      currentTabHeigth: currentTabHeigth
    })]
  });
}
export default /*#__PURE__*/memo(Tabs);